/**
 * Unified site logo: icon tile + two-line wordmark (header/footer, all pages).
 * @param {{ variant?: 'footer' | 'header', colorTheme?: 'light' | 'dark' }} props
 */
export function SiteBrandMark({ variant = 'footer', colorTheme = 'light' }) {
  const inHeader = variant === 'header'
  const theme = colorTheme === 'dark' ? 'dark' : 'light'
  return (
    <div
      className={`site-brand-mark site-brand-mark--${theme}${inHeader ? ' site-brand-mark--in-header' : ' site-brand-mark--in-footer'}`}
    >
      <span className="site-brand-mark__icon-wrap" aria-hidden={inHeader}>
        <img
          src="/icon_only.svg"
          alt=""
          className="site-brand-mark__icon"
          width={36}
          height={36}
          decoding="async"
          loading="lazy"
        />
      </span>
      <span className="site-brand-mark__wordmark">
        <span className="site-brand-mark__line">Prime Document</span>
        <span className="site-brand-mark__line site-brand-mark__line--accent">Sign</span>
      </span>
    </div>
  )
}

/** @deprecated Use SiteBrandMark — kept for existing imports */
export function HomeLightBrandMark({ variant = 'footer', colorTheme = 'light' }) {
  return <SiteBrandMark variant={variant} colorTheme={colorTheme} />
}
